module.exports = __webpack_public_path__ + "static/media/spaceman-mobile.1f800605.svg";